import { render, staticRenderFns } from "./liveList.vue?vue&type=template&id=875ef5a6"
import script from "./liveList.vue?vue&type=script&lang=js"
export * from "./liveList.vue?vue&type=script&lang=js"
import style0 from "./liveList.vue?vue&type=style&index=0&id=875ef5a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports